<template>
  <layout-page>
    <section-page
      title="Communication Log"
      full-height
    >
      <template v-slot:right>
        <comms-filters></comms-filters>
      </template>

      <comms-list></comms-list>
    </section-page>
  </layout-page>
</template>

<script>
import CommsFilters from "./components/CommsFilters";
import CommsList from "./components/CommsList";

export default {
  name: 'CommsPageDesktop',
  components: {
    CommsList,
    CommsFilters
  },
}
</script>
